import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _classCallCheck from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import "core-js/modules/es6.function.name.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// User Model
import VuexORM from '@vuex-orm/core';
import Vue from 'vue';
import Company from "./Company";
import CompanyUser from "./CompanyUser";
var User = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(User, _VuexORM$Model);
  var _super = _createSuper(User);
  function User() {
    _classCallCheck(this, User);
    return _super.apply(this, arguments);
  }
  _createClass(User, null, [{
    key: "entity",
    get:
    // This is the name used as module name of the Vuex Store.
    function get() {
      return 'users';
    }

    // List of all fields (schema) of the user model. `this.attr` is used
    // for the generic field type. The argument is the default value.
  }, {
    key: "fields",
    value: function fields() {
      return {
        id: this.attr(null),
        name: this.attr(''),
        billing_first_name: this.attr(''),
        billing_last_name: this.attr(''),
        email: this.attr(''),
        superuser: this.boolean(false),
        me: this.attr(''),
        company_id: this.number(''),
        company: this.belongsTo(Company, 'company_id'),
        companies: this.belongsToMany(Company, CompanyUser, 'user_id', 'company_id')
      };
    }
  }, {
    key: "$login",
    value: function $login(credentials) {
      return Vue.prototype.$axios.post('/oauth/token', {
        client_id: process.env.CLIENT_ID,
        client_secret: process.env.CLIENT_SECRET,
        grant_type: 'password',
        username: credentials.email,
        password: credentials.password
      }).then(function (response) {
        localStorage.setItem('access_token', response.data.access_token);
        Vue.prototype.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
      });
    }
  }, {
    key: "$logout",
    value: function $logout() {
      localStorage.removeItem('access_token');
      Vue.prototype.$axios.defaults.headers.common.Authorization = '';
    }
  }, {
    key: "$register",
    value: function $register(credentials) {
      return Vue.prototype.$axios.post('/api/register', _objectSpread({}, credentials)).then(function (response) {
        localStorage.setItem('access_token', response.data.access_token);
        Vue.prototype.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
      });
    }
  }, {
    key: "$resetPasswordRequest",
    value: function $resetPasswordRequest(email) {
      return Vue.prototype.$axios.post('/api/password/reset-request', {
        email: email
      });
    }
  }, {
    key: "$resetPassword",
    value: function $resetPassword(password, passwordConfirmation, token) {
      return Vue.prototype.$axios.post('/api/password/reset', {
        password: password,
        password_confirmation: passwordConfirmation,
        token: token
      });
    }
  }, {
    key: "$newCompany",
    value: function $newCompany(name) {
      return Vue.prototype.$axios.post('/api/companies', {
        name: name
      }).then(function (response) {
        User.insert({
          data: response.data
        });
      });
    }
  }, {
    key: "$switchCompany",
    value: function $switchCompany(companyId) {
      return Vue.prototype.$axios.get("/api/me/switch-company/".concat(companyId)).then(function (response) {
        User.insert({
          data: response.data
        });
      });
    }
  }, {
    key: "accessToken",
    value: function accessToken() {
      return localStorage.getItem('access_token');
    }
  }, {
    key: "$getMe",
    value: function $getMe(includeSubscription) {
      return Vue.prototype.$axios.get("/api/me".concat(includeSubscription ? '?get_subscription=true' : '')).then(function (response) {
        User.insert({
          data: response.data
        });
        window.bugsnagClient.user = {
          id: response.data.id,
          name: response.data.name,
          email: response.data.email
        };
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: "$createCustomerPortalSession",
    value: function $createCustomerPortalSession(credentials) {
      return Vue.prototype.$axios.post('/api/me/create_customer_portal_session').then(function (response) {
        return response.data;
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: "$getUserFromResetPasswordToken",
    value: function $getUserFromResetPasswordToken(token) {
      return Vue.prototype.$axios.get('/api/users/token/' + token).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: "me",
    value: function me() {
      return User.query().withAllRecursive().where('me', true).first();
    }
  }]);
  return User;
}(VuexORM.Model);
export { User as default };